// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekBlock-moduleCalendarGridWeekBlock__A0xR4";
var _2 = "CalendarGridWeekBlock-modulebrand__RhhRn";
var _3 = "CalendarGridWeekBlock-modulecompact__QahM2";
var _4 = "CalendarGridWeekBlock-moduledisabled__nNf9a";
var _5 = "CalendarGridWeekBlock-modulefree__TRl7Y";
var _6 = "CalendarGridWeekBlock-modulegold__N2TQ4";
var _7 = "CalendarGridWeekBlock-modulegreen__Km29O";
var _8 = "CalendarGridWeekBlock-modulemuted__hER3d";
export { _1 as "CalendarGridWeekBlock", _2 as "brand", _3 as "compact", _4 as "disabled", _5 as "free", _6 as "gold", _7 as "green", _8 as "muted" }
